import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LinkStyled = styled(Link)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  width: fit-content;

  animation: fadeIn 500ms ease-in-out;
  animation-delay: 900ms;
  animation-fill-mode: backwards;

  @include respond(phone) {
    display: none;
  }

  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
  color: ${({ theme }) => theme.old.colors.white};
  transition: color 200ms;

  :hover {
    color: ${({ theme }) => theme.old.colors.gray[750]};
  }
`
